export default __webpack_public_path__ + "static/media/ipX4.522d614e.svg";